import { QueryClient } from "@tanstack/react-query";

/**
 * Shared QueryClient singleton.
 *
 * Kept in its own module so components can import it without pulling in
 * src/index.jsx (which contains top-level await and is not safe to include
 * in non-async module graphs such as the MFE IIFE bundle).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
